<template>
    <v-card flat class="mail-entry v-flex" @click="onClick" :ripple = "false">
        <div>
            <p-inc-outbox-avatar
                :sender = "mail.from"
                :dense  = "true"
            />
        </div>
        <div style="width: calc(100% - 64px)">
            <div class="mail-title v-flex">
                <div class="mail-to">
                    {{ mail.to }}
                </div>
                <v-spacer />
                <div class="mail-sended">
                    {{ sended }}
                </div>
            </div>
            <div class="mail-subject" >
                {{ mail.subject }}
            </div>
            <div class="ml-2 pr-3 mail-footer v-flex" >
                <div class="">
                    {{ mail.stepName }}
                </div>
                <v-spacer />
                <div class="primary--text">
                    {{ mail.customerName }}
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
import Core from "@/modules/core/service/Core";
import PIncOutboxAvatar from "@/modules/inc/outbox/components/private/PIncOutboxAvatar.vue";

export default {
    name: "PIncOutboxEntry",
    components: {PIncOutboxAvatar},

    props: {
        mail: {

        }
    },

    computed: {
        sended () {
            return Core.format.shorttime(this.mail.sended);
        }
    },

    methods: {
        onClick () {
            this.$emit("selected", this.mail);
        }
    }
}
</script>

<style scoped>

.mail-entry {
    height: 90px;
    width: 100%;
}

.mail-sended {
    font-size: 14px;
    font-weight: 400;
    padding-right: 12px;
    padding-top: 2px;
}


.mail-title {
    padding-left: 8px;
    padding-top: 12px;

}

.mail-to {
    max-width: calc(100% - 60px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 600;
}

.mail-subject {
    padding-left: 8px;
    max-width: calc(100% - 10px);
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.mail-footer {
    font-size: 14px;

}

</style>